const createMemberGuard = <T extends string>(values: T[] | readonly T[]) => {
  const set = new Set<string>(values);

  const predicate = (value: string | number | null | undefined): value is T =>
    !!value && typeof value === 'string' && set.has(value);

  return {
    predicate,
    set,
  };
};

const createEnumGuard = <T extends string>(enumObj: { [key: string]: T }) => {
  const values = Object.values(enumObj);

  return {
    ...createMemberGuard(values),
    values,
  };
};

const createKeyGuard = <T extends string>(record: { [Key in T]: unknown }) => {
  const keys = Object.keys(record) as T[];

  return {
    ...createMemberGuard(keys),
    keys,
  };
};

export { createEnumGuard, createKeyGuard, createMemberGuard };
